import { parseOptions } from './Utils.js'

function map( data, func, opts ) {
  const options = parseOptions( opts, Infinity )
  options.limit = Infinity
  return doMap( data, func, options )
}

function mapLimit( data, func, opts ) {
  const options = parseOptions( opts, 10 )
  return doMap( data, func, options )
}

async function doMap( data, func, opts ) {
  const { limit, handleReject } = opts

  let next = limit
  let error = false

  const results = []
  await Promise.all( data.slice( 0, limit ).map( async ( dataItem, i ) => {
    let index = i
    while ( !error && index < data.length ) {
      try {
        results[index] = await func( data[index], index ) //eslint-disable-line
      } catch ( err ) {
        if ( handleReject ) {
          results[index] = err
        } else if ( error === false ) {
          error = true
          throw err
        }
      }
      index = next++
    }
  } ) )

  return results
}

export default {
  map, 
  mapLimit
}
